<template>
  <div class="user">
    <div class="photo">
      <img-with-fallback :src="avatar" alt="avatar" />
    </div>
    <div class="user-info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click.stop="toggleMenu" @click.capture="clicked">
        <span style="margin-top: -10px">
          {{ title }}
        </span>
        <b class="caret"></b>
        <span v-if="subtitle && subtitle !== ''" class="user-role">
          {{ subtitle }}
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li>
                <router-link :to="{ name: 'Perfil de usuario' }">
                  <span class="sidebar-mini">MP</span>
                  <span class="sidebar-normal">Mi Perfil</span>
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'Editar perfil' }">
                  <span class="sidebar-mini">EP</span>
                  <span class="sidebar-normal">Editar Perfil</span>
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'Cambiar contraseña' }">
                  <span class="sidebar-mini">CC</span>
                  <span class="sidebar-normal">Cambiar contraseña</span>
                </router-link>
              </li>
              <li>
                <a @click="logout">
                  <span class="sidebar-mini">L</span>
                  <span class="sidebar-normal">Salir</span>
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import authService from "@/services/auth";

export default {
  components: {
    CollapseTransition,
  },
  props: {
    title: {
      type: String,
      default: "Usuario JB",
    },
    subtitle: {
      type: String,
    },
    avatar: {
      type: String,
      default: require("@/assets/images/faces/avatar.jpg"),
    },
  },
  data() {
    return {
      isClosed: true,
    };
  },
  methods: {
    clicked: function (e) {
      e.preventDefault();
    },
    toggleMenu: function () {
      this.isClosed = !this.isClosed;
    },
    logout: function () {
      authService.apiLogout();
    },
  },
};
</script>
<style lang="scss" scoped>
.collapsed {
  transition: opacity 1s;
}

.user-role {
  color: #ddd;
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Layout/Extra/UserMenu.vue